/*
* This code is the intellectual property of Bulb Inc. and other software publishers;
* it may not be altered, copied or disclosed without prior written approval.
* Copyright 2022, Bulb Inc. For more information, please email contact@hellobulb.com.
*/

import {
  Component, forwardRef, Input, OnInit,
} from '@angular/core';
import {
  ControlValueAccessor, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, NG_VALUE_ACCESSOR,
} from '@angular/forms';
import { MenuItem } from '../types';

@Component({
  selector: 'bulb-menubar-item-action',
  templateUrl: './menubar-item-action.component.html',
  styleUrls: ['./menubar-item-action.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MenubarItemActionComponent),
      multi: true,
    },
  ],
  standalone: false,
})
export class MenubarItemActionComponent implements OnInit, ControlValueAccessor {
  @Input() menuItem: MenuItem;

  onChange = (value: any) => {};

  onTouched = () => {};

  private value: any;

  formGroup: UntypedFormGroup = this.fb.group({});

  public models: Array<string>;

  constructor(private fb: UntypedFormBuilder) { }

  writeValue(value: any): void {
    this.value = value;
    this.onChange(value);
    this.formGroup.patchValue({
      menuListPanelControl: { [this.menuItem.model]: value },
    });
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  ngOnInit() {
    if (this.menuItem.type === 'MENU_PANEL') {
      this.formGroup.addControl('menuListPanelControl', new UntypedFormControl(this.value));

      // TODO: unsubscribe
      this.formGroup.valueChanges.subscribe((value) => {
        this.onChange({ [this.menuItem.model]: value.menuListPanelControl[this.menuItem.model] });
      });
    }

  }
}
